import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { FC, useState } from 'react';
import { IBotDetail } from 'interface';

interface BotAuthenticateProps {
    botDetail: IBotDetail;
    setBotAuthenticated: (value: boolean) => void;
}

const BotAuthenticate: FC<BotAuthenticateProps> = ({ botDetail, setBotAuthenticated }) => {
    const [password, setPassword] = useState('');
    const [passwordInvalid, setPasswordInvalid] = useState(false);

    const handlePasswordSubmit = () => {
        const isValidPassword = password.trim() === botDetail.botSettings.accessPassword.trim();
        setBotAuthenticated(isValidPassword);
        setPasswordInvalid(!isValidPassword);
    };

    return (
        <div className="access-denied-container">
            <div className="content">
                <img src={"https://storage.googleapis.com/seek-logos/ibexco-assests/access-denied.svg"} alt="Protected bot" />
                <h1 className="title">This bot is protected</h1>
                <p className="message">Please enter password to interact with bot</p>
                <Password
                    className={`input-field ${passwordInvalid ? 'p-invalid' : ''}`}
                    value={password}
                    feedback={false}
                    toggleMask={true}
                    placeholder="Enter your password here"
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setPasswordInvalid(false);
                    }}
                    onKeyDown={(e) => e.key === 'Enter' && handlePasswordSubmit()}
                />

                <Button className="btn password-btn" onClick={handlePasswordSubmit}>
                    Enter
                </Button>
                {passwordInvalid && (
                    <p className="error">{password.trim() === '' ? 'Password required' : 'Invalid Password'}</p>
                )}
            </div>
        </div>
    );
};

export default BotAuthenticate;
